import { createSlice } from "@reduxjs/toolkit";



export const productSlice = createSlice({
  name: 'products',
  initialState: {
    data: [],
    productToBuy: {
      id: null,
      qt: null,
      subTotal: 0,
      priceCilinder: 0,
      qtCilinders: 1
    },
    loading: false
  },
  reducers: {
    requestProducts: (state) => {
      state.loading = true
    },
    productData: (state, {payload}) => {
      state.data = payload.sort((a, b) => {
        return a.capacity - b.capacity
      })
      state.loading = false
    },
    setProductToBuy: (state,  {payload} ) => {
      
      const { byCost, quantity, capacity, price, index } = payload
      if(byCost === undefined || price) {
        
        state.productToBuy.qtCilinders = quantity
        state.productToBuy.priceCilinder = price
        state.productToBuy.subTotal = state.productToBuy.priceCilinder * quantity
      }


      if(byCost){
        let lts = quantity / state.data[0].price;
        // const price = state.data[0].price
        // 
        state.productToBuy.qt = lts.toFixed(2);
        state.productToBuy.subTotal =  quantity.toFixed(2);
      } else {
        let newSubtotal = quantity * state.data[0].price
        
        state.productToBuy.qt = quantity;
        state.productToBuy.subTotal =  newSubtotal.toFixed(2);
      }
    },
    setProductId: (state, { payload }) => {
      state.productToBuy.id = payload;
    }
  }
})

export const { requestProducts, productData, setProductToBuy, setProductId } = productSlice.actions